/**
 * Created by emanuele on 23/05/2017.
 */
import React, {Component} from 'react';
import PrintButton from '../PrintButton'
import PdfButton from '../PdfButton'
import ReportOrganizzazioniTabularView from '../report/ReportOrganizzazioniTabularView'
import RubricaElencoOrganizzazioni from '../../pdf/RubricaElencoOrganizzazioni';

class OrganizzazioniReportList extends Component {

    constructor(props) {
        super(props);
        this.pdfExport = this.pdfExport.bind(this);
    }

    pdfExport() {
        let ce = new RubricaElencoOrganizzazioni();
        ce.setTitle("Report Organizzazioni");
        ce.setFileName("report-organizzazioni.pdf");
        ce.setFilterDescription(this.props.filterDescription);
        ce.createPdf(this.props.items);
    }

    render(){
        return (
            <div className="ui segments">
                <div className="ui secondary segment no-print">
                    <div className="ui three column stackable grid">
                        <div className="row">
                            <div className="column">
                                <PrintButton />
                                <PdfButton onClick={(ev) => (this.pdfExport())} />
                            </div>
                            <div className="column">
                            </div>
                            <div className="column">
                            </div>
                        </div>
                    </div>
                </div>
                <div id="printme" className="ui segment">
                    <ReportOrganizzazioniTabularView {...this.props} />
                </div>
            </div>
        )
    }
}

export default OrganizzazioniReportList;


/** WEBPACK FOOTER **
 ** ./src/components/rubrica/OrganizzazioniReportList.js
 **/